






















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  BCard,
  BRow,
  BCol,
  BSpinner,
  BTable,
  BButtonGroup,
  BButton,
  BFormCheckbox,
  VBTooltip,
  BModal,
} from "bootstrap-vue";
import { DetailsUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { successAlert, errorAlert } from "@/libs/sweetAlerts/alerts";
import appSettings from "@/appSettings";

@Component({
  components: {
    BCard,
    BTable,
    BButton,
    BRow,
    BCol,
    BButtonGroup,
    BSpinner,
    BFormCheckbox,
    BModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  name: "view-utilisateur-administration",
})
export default class ViewUtilisateurAdministration extends Vue {
  @Prop({ required: true }) initialUtilisateur!: DetailsUtilisateur;

  selectedUtilisateur: DetailsUtilisateur | null = null;
  tableColumns = [{ key: "nom", sortable: true }];

  userCanViewPrivateMember: boolean = false;

  hasPlatform = appSettings.hasPlatform();

  agendaLabel = appSettings.getAgendaProviderLabel();

  get currentUtilisateur(): DetailsUtilisateur | null {
    return this.selectedUtilisateur ?? this.initialUtilisateur ?? null;
  }

  @Watch("initialUtilisateur", { immediate: true, deep: true })
  onInitialUtilisateurChange() {
    this.resetModel();
  }

  async mounted() {
    this.resetModel();
    this.getAllowedViewPrivateUser();
  }

  async update() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur || !this.initialUtilisateur) return;

    await this.$http.myressif.utilisateurs
      .update(utilisateur.id, this.initialUtilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "L'utilisateur a bien été mis à jours",
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  async getAllowedViewPrivateUser() {
    await this.$http.myressif.parametres
      .getByNom("fonctions_allowed_privatemember_access")
      .then((res: any) => {
        this.userCanViewPrivateMember = JSON.parse(res.valeur).some((x: string) => this.$store.state.user.fonctions_codes.includes(x))
      });
  }

  async unconfirmEmail() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur || !this.initialUtilisateur) return;

    this.initialUtilisateur.emailConfirmed = false;
    await this.$http.myressif.utilisateurs
      .update(utilisateur.id, this.initialUtilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "L'email à bien été déconfirmé",
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  showRemoveAccountModal() {
    this.$bvModal.show('remove-account-modal');
  }

  async removeAccount() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur) return;

    await this.$http.myressif.utilisateurs
      .removeAccount(utilisateur.id)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Le compte a bien été supprimé",
          });

          this.$router.push({ name: 'utilisateurs' })
        },
        (error: any) => {
          console.log(error);
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: `Une erreur s'est produite lors de la suppression du compte: ${error.message}`,
            });
          }
        }
      );
  }

  async askConfirmEmail() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur) return;

    await this.$http.myressif.utilisateurs
      .askConfirmEmailManually(utilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "La demande à bien été envoyée",
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  async askResetPassword() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur) return;

    await this.$http.myressif.utilisateurs
      .askResetPassword(utilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "La demande à bien été envoyée",
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  async confirmEmail() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur) return;

    await this.$http.myressif.utilisateurs
      .confirmEmail(utilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Confirmation",
            text: "Votre email à bien été confirmé",
          });
          this.initialUtilisateur.emailConfirmed = true;
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  async unlockAccount() {
    const utilisateur = this.currentUtilisateur;
    if (!utilisateur || !this.initialUtilisateur) return;

    this.initialUtilisateur.lockoutEnd = null;
    await this.$http.myressif.utilisateurs
      .update(utilisateur.id, this.initialUtilisateur)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Le compte a bien été débloqué",
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  resetModel() {
    this.selectedUtilisateur = this.initialUtilisateur
      ? JSON.parse(JSON.stringify(this.initialUtilisateur))
      : null;
  }
}
